import React, { useState } from 'react';
import { ClipboardList, UserPlus } from 'lucide-react';
import ManualOnboarding from './ManualOnboarding';
import CandidateInvites from './CandidateInvites';

/**
 * Two onboarding routes into the company, sharing the same super admin approval step:
 *  - Manual Entry: HR fills in the full employee record themselves (the original flow).
 *  - Candidate Invites: the candidate fills in their own details, then HR reviews them.
 */
const TABS = [
  {
    key: 'manual',
    label: 'Manual Entry',
    icon: ClipboardList,
    hint: 'Fill in the full employee record yourself, then send it for super admin approval',
  },
  {
    key: 'invites',
    label: 'Candidate Invites',
    icon: UserPlus,
    hint: 'Email a candidate temporary credentials so they complete their own onboarding form',
  },
];

const Onboarding = ({ onSidebarCountsRefresh }) => {
  const [tab, setTab] = useState('manual');
  const active = TABS.find((t) => t.key === tab);

  return (
    <div className="space-y-6">
      <div>
        <div className="flex flex-wrap gap-2">
          {TABS.map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${
                tab === key
                  ? 'bg-primary-600 text-white border-primary-600'
                  : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'
              }`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </button>
          ))}
        </div>
        <p className="mt-2 text-sm text-gray-500">{active.hint}</p>
      </div>

      {tab === 'manual' ? (
        <ManualOnboarding />
      ) : (
        <CandidateInvites onSidebarCountsRefresh={onSidebarCountsRefresh} />
      )}
    </div>
  );
};

export default Onboarding;
